/**
 * @desc Global actions
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import axios from "axios";

export default {
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  // Action for GET ALL from api, calls mutationGetGeoJson
  actions: {
    // EDIT item
    actionEditGeoJson: function({ commit }, layerData) {
      axios
        .patch(layerData.url, layerData.payload, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
        })
        .then(() => {
          // set vis of snackbar to true
          commit("mutationDialogSnackbarSaved", {
            state: true
          });
        });
    },
    // ADD item
    actionAddGeoJson: function({ commit }, layerData) {
      axios
        .put(layerData.url, layerData.payload, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
        })
        .then(() => {
          // set vis of snackbar to true
          commit("mutationDialogSnackbarSaved", {
            state: true
          });
        });
    },
    // ADD item with image
    actionAddJsonImage: function({ commit }, layerData) {
      // Put JSON
      axios
        .put(layerData.url, layerData.payload, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
          // Then get the response and put image
        })
        .then(response => {
          let imageConst = {
            belongstoid: response.data[0],
            description: "one day...",
            base64data: layerData.base64data
          };
          axios
            .put(layerData.imageUrl, imageConst, {
              headers: {
                Authorization: "Bearer " + layerData.token
              }
            })
            .then(() => {
              // set vis of snackbar to true
              commit("mutationDialogSnackbarSaved", {
                state: true
              });
            });
        });
    },
    // EDIT item with image
    actionEditJsonImage: function({ commit }, layerData) {
      // Put JSON
      axios
        .patch(layerData.url, layerData.payload, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
          // Then get the response and put image
        })
        .then(() => {
          let imageConst = {
            belongstoid: layerData.belongstoid,
            description: "one day...",
            base64data: layerData.base64data
          };
          axios
            .put(layerData.imageUrl, imageConst, {
              headers: {
                Authorization: "Bearer " + layerData.token
              }
            })
            .then(() => {
              // set vis of snackbar to true
              commit("mutationDialogSnackbarSaved", {
                state: true
              });
            });
        });
    },
    // DELETE item
    actionDeleteGeoJson: function({ commit }, layerData) {
      axios
        .delete(layerData.url, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
        })
        .then(() => {
          commit("mutationDialogSnackbarSaved", {
            state: true
          });
        });
    },
    // GET Image
    actionGetImage: function({ commit }, layerData) {
      axios
        .get(layerData.url, {
          headers: {
            Authorization: "Bearer " + layerData.token
          }
        })
        .then(
          response => {
            commit("mutationUiImageFilename", {
              filename: response.data
            });
          },
          err => {
            commit("mutationUiImageFilename", {
              filename: null
            });
            console.log(err);
          }
        );
    },
    // GET GeoJSON
    actionGetGeoJson: function({ commit }, layerData) {
      // set the loading vuex state to true just before we use axios to fetch data
      commit("mutationGetGeoJsonLoading", {
        dept: layerData.dept,
        layer: layerData.layer,
        token: layerData.token,
        loadingState: true
      });
      return new Promise((resolve, reject) => {
        // fetch data
        axios
          .get(layerData.url, {
            headers: {
              Authorization: "Bearer " + layerData.token
            }
          })
          .then(
            response => {
              // commit returned data to vuex store
              commit("mutationGetGeoJson", {
                data: response.data,
                dept: layerData.dept,
                layer: layerData.layer
              });
              // commit loading vuex state to false now that response has returned
              commit("mutationGetGeoJsonLoading", {
                dept: layerData.dept,
                layer: layerData.layer,
                loadingState: false
              });
              resolve();
            },
            err => {
              reject();
              // if err status === 401, display unauth dialog.
              // Otherwise it should just keep trying in the background (network error, etc)
              if (err.response.status === 401) {
                commit("mutationAuthState", {
                  bool: false
                });
                commit("mutationMapLayer", {
                  dept: layerData.dept,
                  layer: layerData.layer
                });
                // SHOW LOGIN SCREEN HERE.
              }
            }
          );
      });
    }
  }
};
